<template>
  <Page>
    <div>
      <h1 class="page-header-1 mb-4">Marketplace</h1>
      <div class="d-flex marketplace-content">
        <FeatureFlag feature="api_access">
          <ApiAccessMarketplaceCard />
        </FeatureFlag>
        <FeatureFlag feature="broccoli_marketplace_card">
          <BroccoliMarketplaceCard ref="broccoli" />
        </FeatureFlag>
        <CallRailMarketplaceCard />
        <CampDigitalMarketplaceCard ref="camp_digital" />
        <FeatureFlag feature="dialpad_integration_ff_enabled">
          <DialpadMarketplaceCard />
        </FeatureFlag>
        <FeatureFlag feature="ghl_integration">
          <GHLMarketplaceCard />
        </FeatureFlag>
        <GPIMarketplaceCard />
        <JBWarrantiesMarketplaceCard />
        <PulseMMarketplaceCard />
        <FeatureFlag feature="qbo_direct">
          <QuickbooksMarketplaceCard ref="qbo" />
        </FeatureFlag>
        <FeatureFlag feature="ringcentral_ff_enabled">
          <RingCentralMarketplaceCard />
        </FeatureFlag>
        <ServiceFinanceMarketplaceCard />
        <StaxPaymentsMarketplaceCard />
        <FeatureFlag feature="integration_webhooks">
          <WebhooksMarketplaceCard />
        </FeatureFlag>
        <ZapierMarketplaceCard />
      </div>
    </div>
  </Page>
</template>

<script>
import { mapActions } from "vuex";
import { getQueryVariables } from "@/lib/url";

import Card from "@/components/Card.vue";
import FeatureFlag from "@/components/FeatureFlag.vue";
import Page from "@/components/Page.vue";
import ApiAccessMarketplaceCard from "@/Marketplace/ApiAccessMarketplaceCard.vue";
import BroccoliMarketplaceCard from "@/Marketplace/BroccoliMarketplaceCard.vue";
import CampDigitalMarketplaceCard from "@/Marketplace/CampDigitalMarketplaceCard.vue";
import DialpadMarketplaceCard from "@/Marketplace/DialpadMarketplaceCard.vue";
import StaxPaymentsMarketplaceCard from "@/Marketplace/StaxPaymentsMarketplaceCard.vue";
import CallRailMarketplaceCard from "./CallRailMarketplaceCard.vue";
import GHLMarketplaceCard from "./GHLMarketplaceCard.vue";
import GPIMarketplaceCard from "./GPIMarketplaceCard.vue";
import JBWarrantiesMarketplaceCard from "./JBWarrantiesMarketplaceCard.vue";
import PulseMMarketplaceCard from "./PulseMMarketplaceCard.vue";
import QuickbooksMarketplaceCard from "./QuickbooksMarketplaceCard.vue";
import RingCentralMarketplaceCard from "./RingCentralMarketplaceCard.vue";
import ServiceFinanceMarketplaceCard from "./ServiceFinanceMarketplaceCard.vue";
import WebhooksMarketplaceCard from "./WebhooksMarketplaceCard.vue";
import ZapierMarketplaceCard from "./ZapierMarketplaceCard.vue";

export default {
  components: {
    ApiAccessMarketplaceCard,
    BroccoliMarketplaceCard,
    CampDigitalMarketplaceCard,
    DialpadMarketplaceCard,
    Card,
    Page,
    FeatureFlag,
    CallRailMarketplaceCard,
    GHLMarketplaceCard,
    PulseMMarketplaceCard,
    ZapierMarketplaceCard,
    GPIMarketplaceCard,
    JBWarrantiesMarketplaceCard,
    RingCentralMarketplaceCard,
    StaxPaymentsMarketplaceCard,
    ServiceFinanceMarketplaceCard,
    QuickbooksMarketplaceCard,
    WebhooksMarketplaceCard
  },
  props: {
    tenantId: { type: Number, default: null }
  },
  async mounted() {
    await this.fetchPaymentMethodsSettings();

    const queryVariables = getQueryVariables();

    if (queryVariables.card) {
      const card = queryVariables.card;

      // VueJS does not have refs ready on mounted() for
      // components inside a v-if - which FeatureFlag ones are
      for (let i = 0; i < 5; i++) {
        if (this.$refs[card]) {
          try {
            this.$refs[card].openModal();
          } catch (e) {
            console.log(e.message);
          }
          break;
        }

        await this.$nextTick();
        await new Promise((r) => setTimeout(r, 200));
      }
    }
  },
  methods: {
    ...mapActions(["fetchPaymentMethodsSettings"])
  }
};
</script>

<style lang="scss" scoped>
.marketplace-content {
  display: flex;
  flex-wrap: wrap;
}
</style>
